/* card-variant-swatch.js */
(function () {
  console.log('[CARD SWATCH] JS LOADED ✅');

  function findCard(el){
    return el.closest('.product-card')
      || el.closest('.card')
      || el.closest('li.grid__item')
      || el.closest('.product-grid-item')
      || el.closest('.grid-product')
      || el.closest('.product-item')
      || el.closest('.product');
  }

  function updateCard(card, input){
    if (!card || !input) return;

    const variantId  = input.getAttribute('data-variant-id') || input.value;
    const variantUrl = input.getAttribute('data-variant-url');
    const imgUrl     = input.getAttribute('data-variant-image');

    console.log('[CARD SWATCH] change', { variantId, variantUrl, imgUrl, card });

    // update hrefs inside card
    const links = card.querySelectorAll('a[href*="/products/"], a.product-card__image-link, .product-card__title a');
    links.forEach(a => {
      try {
        const u = new URL(a.href, window.location.origin);
        u.searchParams.set('variant', variantId);
        a.href = variantUrl || u.toString();
      } catch(e) {
        if (variantUrl) a.setAttribute('href', variantUrl);
      }
    });

    // update hidden input for add-to-cart form if exists
    const hidden = card.querySelector('form input[name="id"]');
    if (hidden) hidden.value = variantId;

    // update image
    if (imgUrl) {
      console.log("image exist");
      const img =
        card.querySelector('.product-card__image--primary img') ||
        card.querySelector('.product-card__image-wrapper img') ||
        card.querySelector('.card__media img') ||
        card.querySelector('img');

      if (img) {
        img.src = imgUrl;
        if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
      }
    }

    card.setAttribute('data-variant-updated', variantId);
  }

  function getInputFromEventTarget(target){
    if (!target) return null;


    // direct input
    if (target.matches && target.matches('.product-card-swatches__input')) return target;

    // click on label or dot
    const label = target.closest && target.closest('.product-card-swatches__label');
    if (label) {
      const forId = label.getAttribute('for');
      if (forId) return document.getElementById(forId);
    }
    return null;
  }

  // capture phase
  document.addEventListener('click', function(e){
    const input = getInputFromEventTarget(e.target);
    if (!input) return;

    input.checked = true;
    const card = findCard(input);
    updateCard(card, input);
  }, true);

  document.addEventListener('change', function(e){
    const input = getInputFromEventTarget(e.target);
    if (!input) return;

    const card = findCard(input);
    updateCard(card, input);
  }, true);

})();
